import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { Container } from 'react-bootstrap';
import { LuSettings } from 'react-icons/lu';
import { useHistory } from 'react-router-dom';

import { isFeatureEnabled } from 'helpers';
import { Button, PageHeader } from '_components/_core';

import { ChargesList } from './components';

function Charges({
  activeCompany,
  onFetchCharges,
  onFetchPaymentGateways,
  onFetchContacts,
  user,
}) {
  const history = useHistory();

  useEffect(() => {
    onFetchCharges();
    onFetchPaymentGateways();
    onFetchContacts();
  }, [onFetchCharges, onFetchPaymentGateways, onFetchContacts, activeCompany]);

  if (!isFeatureEnabled('charges', user.flags)) {
    return null;
  }

  return (
    <Container fluid className="content-wrapper">
      <PageHeader
        title="Cobranças"
        variant="small"
        sideContent={
          <Button
            variant="link"
            size="sm"
            className="p-0 m-0 d-flex align-items-center justify-content-center"
            onClick={() => {
              history.push('/cobrancas/configuracoes');
            }}
          >
            <LuSettings className="mr-2" />
            Configurações
          </Button>
        }
      />
      <ReactTooltip />
      <ChargesList />
    </Container>
  );
}

Charges.defaultProps = {
  isCompact: false,
  charges: [],
  paymentGateways: [],
  paymentMethods: [],
  paymentMethodGateways: [],
  recipients: [],
};

Charges.propTypes = {
  activeCompany: PropTypes.object,
  charges: PropTypes.array,
  isLoading: PropTypes.bool,
  onFetchCharges: PropTypes.func.isRequired,
  onCreateCharge: PropTypes.func.isRequired,
  onEditCharge: PropTypes.func.isRequired,
  onDeleteCharge: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  paymentGateways: PropTypes.array,
  adminPaymentGateways: PropTypes.array,
  paymentMethods: PropTypes.array,
  paymentMethodGateways: PropTypes.array,
  recipients: PropTypes.array,

  onFetchPaymentGateways: PropTypes.func.isRequired,
  onFetchPaymentMethods: PropTypes.func.isRequired,
  onFetchPaymentMethodGateway: PropTypes.func.isRequired,
  onCreatePaymentGateway: PropTypes.func.isRequired,
  onUpdatePaymentGateway: PropTypes.func.isRequired,
  onDeletePaymentGateway: PropTypes.func.isRequired,

  onFetchContacts: PropTypes.func.isRequired,
};

export default Charges;
